/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alive_Spicy_Flea_AmuseInputs */

const fr_alive_spicy_flea_amuse = /** @type {(inputs: Alive_Spicy_Flea_AmuseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in`)
};

/**

* @param {Alive_Spicy_Flea_AmuseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const alive_spicy_flea_amuse = /** @type {((inputs?: Alive_Spicy_Flea_AmuseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alive_Spicy_Flea_AmuseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_alive_spicy_flea_amuse(inputs)
});